/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/308-arrow-up-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.5 0l4 4L0 12.5 3.5 16 12 7.5l4 4V0H4.5z"/>'
  }
})
